<div class="bg-m1 flex h-full flex-col items-center justify-center">
  <div class="relative">
    <ngx-spinner
      [name]="spinnerName"
      color="#0084d1"
      bdColor="#00000000"
      size="default"
      type="ball-clip-rotate"
      [fullScreen]="false"
      [disableAnimation]="true"
      [zIndex]="10"
    >
    </ngx-spinner>
  </div>
  <div class="h-[500px]"></div>
</div>
